const ua = window.navigator.userAgent.toLowerCase();

export default {
  // eslint-disable-next-line no-empty-function
  noop: function () {},
  /**
   * 请大家在使用该方法时添加id参数否则方法不执行
   * @param {id,src,callback} opts
   */
  loadScript: function (opts) {
    if (!opts || !opts.id || !opts.src) {
      console.warn('动态加载js请填写唯一标识和加载路径');
      return Promise.reject(new Error('参数错误' + JSON.stringify(opts)));
    }
    let _script = document.getElementById(opts.id);
    if (!_script) {
      _script = document.createElement('script');
      _script.loadPromise = new Promise(function (resolve, reject) {
        try {
          _script.type = 'text/javascript';
          _script.async = !!opts.async;
          _script.src = opts.src;
          _script.id = opts.id;
          if (opts.cross) {
            _script.setAttribute('crossorigin', 'anonymous');
          }
          if (_script.readyState) {
            // IE
            _script.onreadystatechange = function () {
              let readyState = _script.readyState;
              if (readyState === 'loaded' || readyState === 'complete') {
                resolve();
              }
            };
          } else {
            // Others
            _script.onload = function () {
              resolve();
            };
          }
          _script.onerror = function (ex) {
            reject(ex);
          };
          document.getElementsByTagName('head')[0].appendChild(_script);
        } catch (ex) {
          reject(ex);
        }
      });
    }
    if (typeof opts.callback === 'function') {
      _script.loadPromise.then(opts.callback);
    }
    if (typeof opts.errorCallback === 'function') {
      _script.loadPromise.catch(opts.errorCallback);
    }
    return _script.loadPromise;
  },
  loadCss: function (opts) {
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = opts.url;
    head.appendChild(link);
  },
  /**
   * 暂时没有使用
   * @returns
   */
  isInAutohomeApp: function () {
    return ua.indexOf('autohomeapp') !== -1;
  },
  browser: (function () {
    var isIos = function () {
      var ios = !!ua.match(/\(i[^;]+;( U;)? cpu.+mac os x/); // ios终端
      var iPhone = ua.indexOf('iphone') > -1 || ua.indexOf('mac') > -1;
      var iPad = ua.indexOf('ipad') > -1; // 是否iPad
      return !!(ios || iPad || iPhone);
    };

    function isIphoneX() {
      return (
        ua.indexOf('iphone') > -1 &&
        screen.height === 812 &&
        screen.width === 375
      );
    }

    // 是否ie11或edge
    function isIE() {
      return (
        (/msie|trident|edge/i.test(ua) && !/opera/i.test(ua)) ||
        !!window.ActiveXObject ||
        'ActiveXObject' in window
      );
    }

    var result = {
      isDingTalk: !!ua.match(/DingTalk/i),
      isWechat: !!ua.match(/MicroMessenger/i),
      isSafari: !!ua.match(/version\/([\d.]+).*safari/),
      isChrome: !!ua.match(/chrome\/([\d.]+)/),
      isApp: !!ua.match(/auto_android|auto_iphone/i),
      isPriceApp: !!ua.match(/price_ios|price_android/i),
      isUcweb: !!ua.match(/UCWEB|UCBrowser/i),
      isIos: isIos(),
      isIpad: ua.indexOf('ipad') > -1,
      isAndroid: ua.indexOf('android') > -1 || ua.indexOf('linux') > -1,
      isMobile: (function () {
        return !!/(iphone|ios|android|mini|mobile|mobi|nokia|symbian|ipod|ipad|ws\s+phone|mqqbrowser|wp7|wp8|ucbrowser7|ucweb|360\s+aphone\s+browser)/i.test(
          ua,
        );
      })(),
      isQQ: !!ua.match(/qq\/([\d.]+)/i),
      isQQWeb: ua.indexOf('mqqbrowser/') !== -1,
      isIphoneX: isIphoneX(),
      isSwan: /swan\//.test(ua),
      isIE: isIE(),
    };

    return result;
  })(),
  os: (function () {
    var os = {
      iphone: ua.indexOf('iphone') !== -1,
      android: ua.indexOf('android') !== -1,
    };
    return os;
  })(),
  toast: function (msg, timeout = 1) {
    let toast = document.createElement('div');
    toast.style = `position: fixed;
    left: 50%;
    top: 50%;
    z-index: 9999;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    display: inline-block;
    background: rgba(0, 0, 0, 0.9);
    padding: 20px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    -moz-border-box-sizing: border-box;
    box-sizing: border-box;`;
    let toastText = document.createElement('p');
    toastText.style = `color:#fff;
     font-size: 15px;
     line-height: 24px;
     text-align: center;`;
    toastText.innerHTML = msg;
    toast.appendChild(toastText);
    document.body.appendChild(toast);
    setTimeout(function () {
      document.body.removeChild(toast);
    }, 1000 * timeout);
  },
  formatTime: function (date, fmt) {
    if (typeof date === 'string') {
      date = new Date(date.replace('T', ' ').replace(/-/g, '/'));
    }
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
      'H+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
    };
    var week = {
      0: '/u65e5',
      1: '/u4e00',
      2: '/u4e8c',
      3: '/u4e09',
      4: '/u56db',
      5: '/u4e94',
      6: '/u516d',
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length),
      );
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (RegExp.$1.length > 1
          ? RegExp.$1.length > 2
            ? '/u661f/u671f'
            : '/u5468'
          : '') + week[date.getDay() + ''],
      );
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length),
        );
      }
    }
    return fmt;
  },
  getCookie: function (name, defval) {
    var nameEQ = name + '=';
    var result = '';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        result = unescape(c.substring(nameEQ.length, c.length));
      }
    }

    if (result && result !== '' && result !== null) {
      return result;
    } else {
      return typeof defval === 'undefined' ? '' : defval;
    }
  },
  decodeHtml: function (_str) {
    var s = _str.replace(/&#[\dA-F]{2,4};/g, function (_hex) {
      return String.fromCharCode('0' + _hex.slice(2, -1));
    });
    return s;
  },
  getUrlParam: function (name) {
    var reg = new RegExp('(\\?|&|#)' + name + '=([^&#\\?]*)(&|#|\\?|$)', 'i');
    var r = window.location.href.match(reg);
    if (r !== null) {
      return decodeURIComponent(r[2]);
    }
    return '';
  },
  setCookie(opts) {
    var defaults = {
      domain: '.m.autohome.com.cn',
    };
    var options = Object.assign(defaults, opts);
    var cookiestr =
      options.name +
      '=' +
      escape(options.value) +
      ';domain=' +
      options.domain +
      ';path=/;';
    if (options.time && typeof options.time !== 'undefined') {
      var exp = new Date();
      exp.setTime(exp.getTime() + options.time); // 过期时间 2分钟
      cookiestr += 'expires=' + exp.toGMTString();
    }
    document.cookie = cookiestr;
  },
  getAppVersionNum() {
    var version = this.getCookie('app_ver') || '0';
    return parseInt(version.split('.').join(''));
  },
  compareAppVersionNum(
    appVer = {
      majorVer: 0,
      minorVer: 0,
      revision: 0,
    },
  ) {
    // app_ver 格式为[majorVer].[minorVer].[revision] 格式
    var version = String(this.getCookie('app_ver') || '0');
    return this.setCompareAppVersionNum(appVer, version);
  },
  compareIcsAppVersionNum(icsVer, version) {
    return this.setCompareAppVersionNum(icsVer, version);
  },
  setCompareAppVersionNum(appVer, version) {
    const verArr = String(version).split('.');
    if (verArr.length < 3) {
      return false;
    }
    let majorVer = 0;
    let minorVer = 0;
    let revision = 0;
    majorVer = parseInt(verArr[0], 10);
    minorVer = parseInt(verArr[1], 10);
    revision = parseInt(verArr[2], 10);
    if (majorVer > appVer.majorVer) {
      return true;
    }
    if (majorVer === appVer.majorVer && minorVer > appVer.minorVer) {
      return true;
    }
    if (
      majorVer === appVer.majorVer &&
      minorVer === appVer.minorVer &&
      revision >= appVer.revision
    ) {
      return true;
    }
    return false;
  },
  /**
   *
   * @param {值} value
   * @param {保留小数位数} fixed
   * @param {是否以10000为单位进行格式化} isFormat
   * @param {格式化后的单位，默认：万} formatUnit
   */
  numFormat(value, fixed, isFormat = true, formatUnit = '万') {
    if (typeof value !== 'number') {
      return '0';
    }
    if (typeof value === 'number' && value <= 0) {
      return '0';
    }
    if (typeof fixed !== 'number') {
      fixed = 1;
    }
    if (isFormat && value >= 10000) {
      return (value / 10000).toFixed(fixed) + formatUnit;
    }
    return Math.round(value * 100) / 100;
  },
  supportWebGL: (function () {
    if (!('WebGLRenderingContext' in window || window.WebGLRenderingContext)) {
      return false;
    }
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl');
      if (gl === null) {
        gl = canvas.getContext('experimental-webgl');
      }
      if (gl && gl instanceof WebGLRenderingContext) {
        return true;
      } else {
        return false;
      }
    } catch (t) {
      return false;
    }
  })(),

  /**
   *  声网触发前，需要先调用ahapp-2.0.js
   */
  loadAhappScript() {
    console.log('ahappScriptUrl');
    const self = this;
    const ahappScriptUrl = '//x.autoimg.cn/app/scripts/ahapp-2.0.js';
    return new Promise(function (resolve) {
      self.loadScript({
        id: 'ahapp-2.0',
        src: ahappScriptUrl,
        callback: function () {
          resolve();
        },
      });
    });
  },
  isICSApp() {

    return false
    // // 判断是否爱车商端
    // if (
    //   typeof ICSJavascriptBridge === 'undefined' ||
    //   !window.ICSJavascriptBridge
    // ) {
    //   //不在i车商APP中
    //   return false;
    // } else {
    //   return true;
   // }
  },
  generatorPromise() {
    function PromiseGenerator() {
      const executor = (resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      };
      this.promise = new Promise(executor);
      this.then = function (fn) {
        return this.promise.then(fn);
      };
      this.catch = function (fn) {
        return this.promise.catch(fn);
      };
      this.finally = function (fn) {
        return this.promise.finally(fn);
      };
    }
    return new PromiseGenerator();
  },
  getRandomStr(len = 6) {
    const charList =
      'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789';
    const maxLen = charList.length;
    let randomCharList = [];
    for (let i = 0; i < len; i++) {
      let index = Math.floor(Math.random() * maxLen);
      randomCharList.push(charList[index]);
    }
    return randomCharList.join('');
  },
  checkPhone(phone) {
    return /^1[0-9]\d{9}$/.test(phone);
  },
  /**
   * copy内容的元素，注意不支持ie，需要ie下使用请兼容ie代码 document.selection
   * @param { Element } element
   * @returns Boolean
   */
  copy(element) {
    let copySuccessed = false;
    try {
      const selection = window.getSelection();
      selection.removeAllRanges();
      if (
        element instanceof HTMLTextAreaElement ||
        element instanceof HTMLInputElement
      ) {
        element.focus();
        element.select();
      } else {
        const range = document.createRange();
        range.selectNodeContents(element);
        selection.addRange(range);
      }
      if (document.execCommand('copy', false, null)) {
        copySuccessed = true;
      }
      selection.removeAllRanges();
    } catch (err) {
      console.error(err);
    }
    return copySuccessed;
  },
  wanFilterWithUnit(value, fixed = 2) {
    if (typeof value !== 'number') {
      return { value: '-', unit: '' };
    }
    if (value >= 10000) {
      return { value: (value / 10000).toFixed(fixed), unit: '万' };
    }
    return { value: value.toFixed(fixed), unit: '' };
  },
  formatMoney(number) {
    const [first, last] = number.split('.');
    const firstNum = first && first.length && first[0];
    const lastNum = (last && last.length && last[last.length - 1]) || 0;
    const firstLength = first && first.length;
    const lastLength = last && last.length;
    return (
      firstNum +
      '*'.repeat(firstLength - 1) +
      '.' +
      '*'.repeat(lastLength - 1) +
      lastNum
    );
  },
  getDeviceType() {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return 'android';
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      // 注意: 通过 !window.MSStream 排除 Windows Phone
      return 'IOS';
    } else {
      return 'unknown';
    }
  },
   /**
   * 返回yyyy-MM-dd HH:mm:ss
   */
  getTime(date) {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
  },
  isApp(){
    return !!ua.match(/auto_android|auto_iphone/i)
  }

};
